module.exports = __webpack_public_path__ + "img/gmsqyyzz.04077432.png";